export default __webpack_public_path__ + "static/media/thirdIconRight.239008dc.svg";